import { guid } from '@/mixins/guid';

export function tabShape(mrg = {}) {
  return () => (Object.assign({
    _id: guid.methods.guid(),
    title: 'Title',
    droplets: [],
    layout: 'top',
  }, mrg));
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/tabs/utils.js